import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

import Complain from '@/views/Complain.vue';
import Pay from '@/views/Pay.vue';
import PayRights from '@/views/PayRights.vue';
import PayOver from '@/views/PayOver.vue';
import Calculate from '@/views/Calculate.vue';
import Pay2 from '@/views/pay2/Pay.vue';
import Pay3 from '@/views/pay3/Pay.vue';
import Pay3Over from '@/views/pay3/PayOver.vue';
import Pay2Right from '@/views/pay2/Rights.vue';
import Pay2Introduce from '@/views/pay2/Introduce.vue';
import Login from '@/views/pay3/Login.vue';
// 测评
import AppraisalIndex from '@/views/appraisal/Index.vue';
import AppraisalCheckSmall from '@/views/appraisal/CheckSmall.vue';
import AppraisalCheckBig from '@/views/appraisal/CheckBig.vue';
import AppraisalResultSmall from '@/views/appraisal/ResultSmall.vue';
import AppraisalResultBig from '@/views/appraisal/ResultBig.vue';
import AppraisalResultList from '@/views/appraisal/ResultList.vue';
import AppraisalVideoList from '@/views/appraisal/VideoList.vue';
import AppraisalVideoDetail from '@/views/appraisal/VideoDetail.vue';
import StateAnxiety from '@/views/questionnaire/StateAnxiety.vue';
import StateAnxietyResult from '@/views/questionnaire/Result.vue';

import Index from '@/views/pay2/Pay.vue';
import Product from '@/views/pay2/Product.vue';
import ProductD from '@/views/pay2/ProductD.vue';
import ProductTianjin from '@/views/pay2/ProductTianjin.vue';
import ProductShijiazhuang from '@/views/pay2/ProductShijiazhuang.vue';
import ExtraVisit from '@/views/pay2/ExtraVisit.vue';
import ServicePackages from '@/views/pay2/ServicePackages.vue';
import Plan from "@/views/plan/Plan.vue";
import WeeklySummary from "../views/plan/WeeklySummary.vue";
import Neuro from "../views/plan/Neuro.vue";
// 图表
import FeedingChart from "@/views/chart/FeedingChart.vue";
// 龙虾引导页
import Lobster from '@/views/Lobster.vue';
import BabyHome from '@/views/baby/Home.vue';
import BabyAlbum from '@/views/baby/AlbumGallery.vue';
import TcmStudyHome from '@/views/tcmStudy/Home.vue';
import TcmMassagePrepare from '@/views/tcmStudy/MassagePrepare.vue';
import TcmMassageTutorial from '@/views/tcmStudy/MassageTutorial.vue';
import TcmMassageFeedback from '@/views/tcmStudy/MassageFeedback.vue';
import TcmFoodRecipe from '@/views/tcmStudy/FoodRecipe.vue';
import NotFound from '@/views/NotFound.vue';
import ServiceProgress from '@/views/service/Progress.vue';
import GeoHome from '@/views/geo/Home.vue';
import GeoTopic from '@/views/geo/Topic.vue';
import GeoGo from '@/views/geo/Go.vue';
import { syncGeoBaiduTracking, trackBaiduPageview } from '@/utils/analytics';

if (window.location.hash && /^#\/tcm-?study/.test(window.location.hash)) {
    const hashPath = window.location.hash.slice(1);
    window.history.replaceState(null, '', hashPath);
}

const routers = [
    {
        path: '/',
        component: Index
    },
    {
        path: '/complain',
        component: Complain
    },
    {
        path: '/pay',
        component: Pay
    },
    {
        path: '/pay-rights',
        component: PayRights
    },
    {
        path: '/pay-over',
        component: PayOver
    },
    {
        path: '/calc',
        component: Calculate
    },
    {
        path: '/contact',
        component: Pay2
    },
    {
        path: '/rights',
        component: Pay2Right
    },
    {
        path: '/introduce',
        component: Pay2Introduce
    },
    {
        path: '/login',
        component: Login
    },
    {
        path: '/wx/pay',
        component: Pay3
    },
    {
        path: '/wx/pay-over',
        component: Pay3Over
    },
    {
        path: '/appraisal/index',
        component: AppraisalIndex
    },
    {
        path: '/appraisal/check1',
        component: AppraisalCheckSmall
    },
    {
        path: '/appraisal/check2',
        component: AppraisalCheckBig
    },
    {
        path: '/appraisal/result1',
        component: AppraisalResultSmall
    },
    {
        path: '/appraisal/result2',
        component: AppraisalResultBig
    },
    {
        path: '/appraisal/result-list',
        component: AppraisalResultList
    },
    {
        path: '/appraisal/video-list',
        component: AppraisalVideoList
    },
    {
        path: '/appraisal/video-detail',
        component: AppraisalVideoDetail
    },
    {
        path: '/appraisal/state-anxiety',
        component: StateAnxiety
    },
    {
        path: '/appraisal/state-anxiety-result',
        component: StateAnxietyResult
    },
    {
        path: '/pay2/product',
        component: Product
    },
    {
        path: '/pay2/product-tianjin',
        component: ProductTianjin
    },
    {
        path: '/pay2/product-shijiazhuang',
        component: ProductShijiazhuang
    },
    {
        path: '/pay2/extra-visit',
        component: ExtraVisit
    },
    {
        path: '/pay2/extra-visit/:region',
        component: ExtraVisit
    },
    {
        path: '/pay2/service-packages',
        redirect: '/pay2/service-package/nearby'
    },
    {
        path: '/pay2/service-package/nearby',
        component: ServicePackages,
        props: { type: 'nearby' }
    },
    {
        path: '/pay2/service-package/growth',
        component: ServicePackages,
        props: { type: 'growth' }
    },
    {
        path: '/pay2/service-package/neuro',
        component: ServicePackages,
        props: { type: 'neuro' }
    },
    {
        path: '/pay2/service-package/:type',
        component: ServicePackages
    },
    {
        path: '/product/info',
        component: ProductD
    },
    {
        path: '/service/progress',
        component: ServiceProgress
    },
    {
        path: '/geo',
        component: GeoHome
    },
    {
        path: '/geo/topic/:slug',
        component: GeoTopic
    },
    {
        path: '/go/:source/:slug',
        component: GeoGo
    },
    {
        path: '/plan/plan',
        component: Plan
    },
    {
        path: '/plan/weekly-summary',
        component: WeeklySummary
    },
    {
        path: '/plan/neuro-standards',
        component: Neuro
    },
    // 图表页面
    {
        path: '/chart/feeding',
        component: FeedingChart
    },
    {
        path: '/lobster',
        component: Lobster
    },
    {
        path: '/baby',
        redirect: '/baby/home'
    },
    {
        path: '/baby/home',
        component: BabyHome
    },
    {
        path: '/baby/album',
        component: BabyAlbum
    },
    {
        path: '/baby/album/search',
        component: BabyAlbum
    },
    {
        path: '/baby/album/search/date',
        component: BabyAlbum
    },
    {
        path: '/baby/album/search/photo',
        component: BabyAlbum
    },
    {
        path: '/baby/album/search/video',
        component: BabyAlbum
    },
    {
        path: '/tcm-study',
        redirect: '/tcm-study/home'
    },
    {
        path: '/tcm-study/home',
        component: TcmStudyHome
    },
    {
        path: '/tcm-study/massage/prepare',
        component: TcmMassagePrepare
    },
    {
        path: '/tcm-study/massage/tutorial',
        component: TcmMassageTutorial
    },
    {
        path: '/tcm-study/massage/feedback',
        component: TcmMassageFeedback
    },
    {
        path: '/tcm-study/food/recipe',
        component: TcmFoodRecipe
    },
    {
        path: '/tcm-study/operation',
        component: TcmStudyHome
    },
    {
        path: '/tcm-study/feeding',
        component: TcmStudyHome
    },
    {
        path: '/tcm-study/month',
        component: TcmStudyHome
    },
    {
        path: '/tcm-study/abnormal',
        component: TcmStudyHome
    },
    {
        path: '/tcmstudy',
        redirect: '/tcm-study/home'
    },
    {
        path: '/tcmstudy/home',
        component: TcmStudyHome
    },
    {
        path: '/tcmstudy/massage/prepare',
        component: TcmMassagePrepare
    },
    {
        path: '/tcmstudy/massage/tutorial',
        component: TcmMassageTutorial
    },
    {
        path: '/tcmstudy/massage/feedback',
        component: TcmMassageFeedback
    },
    {
        path: '/tcmstudy/food/recipe',
        component: TcmFoodRecipe
    },
    {
        path: '/tcmstudy/operation',
        component: TcmStudyHome
    },
    {
        path: '/tcmstudy/feeding',
        component: TcmStudyHome
    },
    {
        path: '/tcmstudy/month',
        component: TcmStudyHome
    },
    {
        path: '/tcmstudy/abnormal',
        component: TcmStudyHome
    },
    {
        path: '*',
        component: NotFound
    }

];

const router = new Router({
    mode: "history",
    routes: routers
});

router.afterEach((to) => {
    if ((to.path || '').startsWith('/go/')) {
        return;
    }
    syncGeoBaiduTracking(to);
    trackBaiduPageview(to);
});

export default router;
